export const crop = (
  // Scaled ~0.82 about the 28×28 center so the glyph carries the same ~4.5u
  // padding as sibling icons (e.g. fullscreen, plus); the raw path spans
  // 2.5–25.5 and looks oversized/cramped next to them at the same size.
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    transform="translate(14 14) scale(0.82) translate(-14 -14)"
    d="M7 9V20L8 21H19V25.5H21V21H25.5V19H21V8L20 7L9 7V2.5H7V7H2.5V9H7ZM9 9V19H19V9L9 9Z"
    fill="currentColor"
  />
);
